import { inject, injectable } from 'inversify';
import { EGlobalDIKeys } from 'core/di/keys';
import type { IWebSocketService } from '../WebSocketService';
import type { IChannelSettings } from './types';
import Channel from './Channel';

@injectable()
class PrivateChannel extends Channel {
  constructor(
    settings: IChannelSettings,
    @inject(EGlobalDIKeys.WebSocketService)
    private readonly _webSocketService: IWebSocketService,
  ) {
    super(settings);
  }

  getName(): string {
    return `${this._Name}:#${this._webSocketService.getClientId()}`;
  }
}

export default PrivateChannel;
